import { render, staticRenderFns } from "./jfckFrom.vue?vue&type=template&id=e53a9e0c&scoped=true"
import script from "./jfckFrom.vue?vue&type=script&lang=js"
export * from "./jfckFrom.vue?vue&type=script&lang=js"
import style0 from "./jfckFrom.vue?vue&type=style&index=0&id=e53a9e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a9e0c",
  null
  
)

export default component.exports